import React from "react";
import { useField } from "formik";
import FieldError from "./FieldError";

const FormikRadioGroup = ({ label, name, options, required = false }) => {
  const [field, meta] = useField(name);
  const errorId = `${name}-error`;
  const hasError = Boolean(meta.touched && meta.error);

  return (
    <fieldset
      className={`form-group registration-field radio-group${
        hasError ? " field-invalid" : ""
      }`}
      aria-describedby={hasError ? errorId : undefined}
    >
      <legend>
        {label} {required && <span aria-hidden="true">*</span>}
      </legend>
      <div className="radio_input">
        {options.map(({ label: optionLabel, value }) => (
          <label className="container_radio" key={value}>
            {optionLabel}
            <input
              type="radio"
              name={name}
              value={value}
              checked={field.value === value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            <span className="checkmark" aria-hidden="true" />
          </label>
        ))}
      </div>
      <FieldError id={errorId} error={meta.error} touched={meta.touched} />
    </fieldset>
  );
};

export default FormikRadioGroup;
